/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import storeItemManagerImg from '../../assets/imgs/store/store-item-manager.png';
import SearchNotificationsProfile from '../../components/search-notifications-profile/SearchNotificationsProfile';
import StoreWelcomeSharedSection from '../store-pages/store-welcome-shared-section/StoreWelcomeSharedSection';
import TableFilter from './TableFilter';
import PageTable from './PageTable';
import './SingleSupplierPaymentsPage';
import CustomersPaymentsContext from '../../contexts/customers-payments-context/CustomersPaymentsContext';
import SelectedCustomerPayment from './SelectedCustomerPayment';
import {
  useHistory,
  useParams
} from 'react-router-dom/cjs/react-router-dom.min';
import { useTranslation } from 'react-i18next';
import Breadcrumbs from '../../components/breadcrumbs/Breadcrumbs';
const SingleSupplierPaymentsPage = () => {
  const { customerPaymentModalOpened } = React.useContext(
    CustomersPaymentsContext
  );
  const path = useHistory();
  const { t, i18n } = useTranslation();
  const [currentLang, setCurrentLang] = useState();
  useEffect(() => {
    setCurrentLang(i18n.language);
  }, [i18n.language]);
  const params = useParams();

  return (
    <div className="clients-page">
      <div className="top-section-wrap">
        <div className="settings-categories-page">
          <div className="OutgoingPurchaseInvoicePage-page-head-wrap">
            {/* <div className="page-title">
              <h2 className="bold-font">{t('SupplierPays.title')}</h2>
              <p>{t('SupplierPays.subTitle')}</p>
            </div> */}
            <div className="page-title">
              <h2 className="bold-font" style={{ fontSize: '42px' }}>
                {t('SupplierPays.title')}
              </h2>
              <Breadcrumbs
                title1={t('AppBar.Products.homePage')}
                link1={'/'}
                title2={t('AppBar.Products.incomingPurchaseInvoice.title')}
                title3={t(
                  'AppBar.Products.incomingPurchaseInvoice.suppliersPaymentsPage'
                )}
                link3={'/store/suppliers-payments-page'}
                title4={t('SupplierPays.title')}
                link4={`/store/suppliers-payments-page/${params?.id}`}
              />
            </div>
          </div>
        </div>
        <div className="search-wrap">
          <SearchNotificationsProfile noSearch />
        </div>
      </div>
      <TableFilter />
      <div className="suppliersPage-table-wrapper">
        <PageTable currentLang={currentLang} />
      </div>
      {customerPaymentModalOpened && <SelectedCustomerPayment />}
    </div>
  );
};

export default SingleSupplierPaymentsPage;
